<template>
  <div style="width: 100%;">
    <el-row style="padding: 5px;" :gutter="10" v-if="!onlyTable">  
      <el-col :span="10">
    
        <el-tooltip class="item" effect="dark" content="來源為出貨給該客戶的Serial No和Cust Serial No" placement="top">
          <el-select v-model="sn" :placeholder="$t('msg.pleaseSelect')" style="display:block;" :no-data-text="$t('msg.noDataFound')"  
             :filterable=true :allow-create=true  :no-match-text="$t('msg.noDataFound')">
            <el-option v-for="item in snOpts" :key="item" :label="item" :value="item"></el-option>
          </el-select> 
        </el-tooltip>
      </el-col>
      <el-col :span="2"><el-button type="success" @click="addTableData()">{{$t('button.create')}}</el-button></el-col> 
    </el-row>   
    <el-table ref="singleTable" :data="tableData.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')">
      <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
        <template slot-scope="scope">
          <span ><!-- v.field == 'rmaEffectiveDate' || -->
            <el-input v-if="currentIndex==scope.$index && ( v.field == 'pfcd' || v.field=='rmaNumber'|| v.field=='custSerialNo' || v.field == 'bizMode' ||
               v.field == 'rmaShortCode'||v.field == 'modelName'||v.field == 'productId'||v.field == 'panelId'|| v.field == 'deliveryNo' || v.field == 'remark')" 
              size="mini" :placeholder="$t('msg.pleaseEnterContent')"  v-model="scope.row[v.field]" maxlength=50 ></el-input>
            <el-date-picker v-else-if="currentIndex==scope.$index && ( v.field == 'faeProposalDate'||v.field == 'shippingDate')" v-model="scope.row[v.field]"  type="date"  :placeholder="$t('msg.selectDate')" size="mini" style="width:100%" @change="rmaRequestChange(scope.row, scope.$index, v.field)"></el-date-picker>
            <el-select v-else-if="currentIndex==scope.$index && (v.field == 'goodType' || v.field=='defectCode'|| v.field == 'symptom') " v-model="scope.row[v.field]" :placeholder="$t('msg.pleaseSelect')" size="mini" filterable allow-create>
              <el-option v-for="item in v.selectObj" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <span v-else>{{ scope.row[v.field] }}</span>
          </span>
          
        </template>
      </el-table-column>
      <el-table-column :label="$t('action')" width="180" v-if="!onlyTable">
        <template slot-scope="scope">   
          <el-button v-if="currentIndex!=scope.$index" type="warning" @click="updTableData(scope.row, scope.$index, true)">{{$t('button.edit')}}</el-button>
          <el-button v-if="currentIndex==scope.$index" type="success" @click="updTableData(scope.row, scope.$index, true)">{{$t('button.confirm')}}</el-button>
          <el-button v-if="currentIndex!=scope.$index" type="danger" @click="delTableData(scope.row, scope.$index)">{{$t('button.delete')}}</el-button>
          <el-button v-if="currentIndex==scope.$index" type="warning" @click="updTableData(scope.row, scope.$index, false)">{{$t('button.cancel')}}</el-button>         
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-button type="primary" @click="sendRmaMail()" v-if="!onlyTable">{{$t('button.sendRMAMail')}}</el-button>   
  </div>
</template>

<script>
import { apiFindFeedbackRmaByFeedbackId, apiFindSdbShippingSnAndCustSnByCustNo, apiFindSdbShippingBySnAndCustNo, apiSendFeedbackRmaMail } from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";
import CommonUtil from "../../../utils/commonUtil.js";
export default {
  props: {    
    pFeedbackId: {
      type: String
    },
    pCustNo: {
      type: String
    },
    pResp: {
      type: String
    },
    onlyTable: {
      type: Boolean,
      Default: false
    }
  },
  data() {   

    return {
      sn:'',
      snOpts: [],

      currentIndex:-1,    
      tableData: {
        sel: null,
        columns: [  
          { field: "bizMode", title:  this.$i18n.t('field.bizMode'), width: 100 },  
          { field: "customer", title: this.$i18n.t('field.customerNo'), width: 150 },         
          { field: "custSortl", title: this.$i18n.t('field.sortl'), width: 200 },        
          { field: "pfcd", title: this.$i18n.t('field.pfcd'), width: 150 },   
          { field: "goodType", title: this.$i18n.t('field.rmaGoodsType'), width: 200, selectObj:['Local Scrap','Return Analysis','Return Repair','Return Scrap','Return Re-sorting','Return Recycle Bezel']},
          { field: "rmaShortCode", title: this.$i18n.t('field.rmaShortCode'), width: 180 },
          { field: "rmaRequestDate", title: this.$i18n.t('field.rmaRequestDate'), width: 150},
          { field: "modelName", title:'Model Name', width: 150},
          // { field: "cmomodelId", title:'CmomodelID', width: 150},
          { field: "productId", title:'ProductID', width: 150},
          { field: "serialNo", title:'Serial No', width: 150},        
          { field: "panelId", title:'Panel Id', width: 150},
          { field: "shippingDate", title:this.$i18n.t('field.shippingDate'), width: 180},
          // { field: "shipProblem", title:'Number of days from Shipment to problem', width: 180},
          { field: "deliveryNo", title:'Delivery No.', width: 150},
          { field: "symptom", title:this.$i18n.t('field.customerSymptomLevel2'), width: 200},
          { field: "remark", title:'Request Form Remark', width: 200},
          { field: "rmaNumber", title:'RMA Number', width: 150},
          { field: "rmaEffectiveDate", title:this.$i18n.t('field.rmaEffectiveDate'), width: 150},
          { field: "faeProposalDate", title:this.$i18n.t('field.faeProposalDay'), width: 150},
          { field: "defectCode", title: 'Defect Code', width: 150},
          { field: "complaintDateDiff", title:this.$i18n.t('field.custComplaintDateShippingDate'), width: 150},
          { field: "failureStage", title:'Failure stage', width: 200},
          { field: "resp", title:this.$i18n.t('field.judgmentofLiability'), width: 150}

          // { field: "hardwareRepair", title:'Hardware repair part', width: 200}
 

        ],
        data: []
      }
    };
  }, 
  components: {

  },
  watch:{
    pCustNo: function(){
  
      apiFindSdbShippingSnAndCustSnByCustNo({ headers: authHeader(), condition: this.pCustNo}).then((response) => { 
      
       if(response.status== 200 && response.data != null && response.data.length > 0){
          this.snOpts = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  mounted() {    

    if(this.pFeedbackId != null && this.pFeedbackId != ''){
      apiFindFeedbackRmaByFeedbackId({ headers: authHeader(), feedbackId: this.pFeedbackId}).then((response) => { 
        if(response.status== 200 && response.data != null && response.data.length > 0){
          response.data.forEach((item, index) => {  
            let shippingDate = item.shippingDate; 
            if(shippingDate != null && shippingDate!= '' && shippingDate.length > 10){
              shippingDate = shippingDate.substr(0,10);
            }
            item.shippingDate = shippingDate; 
          });
          this.tableData.data = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }

  },
  methods: {
    computeShippingComplaintDateDiff(shippingDate, complaintDate){      
      if(!CommonUtil.isNull(shippingDate) && !CommonUtil.isNull(complaintDate)){    
        return CommonUtil.checkDateDiff(shippingDate, complaintDate);
      }else {
        return 0;
      }
      
    },
    addTableData() {
      let isDuplicate = false;
      this.tableData.data.forEach((item, index) => {          
        if(item.serialNo == this.sn){
            isDuplicate = true;
        }
      });     

      if(isDuplicate){
        this.$message({ type: "error", message: this.$i18n.t('msg.isDuplicateCannotAdd'), duration: 800});
      }else{       
        
        this.genSelsetItem();

        apiFindSdbShippingBySnAndCustNo({ headers: authHeader(), feedbackId: this.pFeedbackId, custNo: this.pCustNo, sn: this.sn}).then((response) => { 
          var data = [];
          var complaintDate= '',shippingDate = '';
          if(response.status== 200 && response.data != null && response.data.length > 0){
            
            data = response.data[0];
            complaintDate = data.complaintDate;
            shippingDate = data.shippingDate;
    
            if(shippingDate != null && shippingDate!= '' && shippingDate.length > 10){
              shippingDate = shippingDate.substr(0,10);
            }  
          }
          var date = new Date(complaintDate);
          var rmaRequestDate = date.getFullYear() + "-" + CommonUtil.lpad(date.getMonth()+1, 2) + "-" + CommonUtil.lpad(date.getDate(), 2);
          debugger
          let j = {    
              rmaRequestDate:rmaRequestDate,
              bizMode:'FPD',
              goodType:'',
              customer: data.custNo,
              custSortl:data.customerSortl,
              rmaShortCode: data.rmaShortCode,
              modelName:data.modelName,
              productId: data.erpProductId,
              serialNo: this.sn,
              panelId: data.panelId,  
              shippingDate: CommonUtil.isNull(shippingDate)?'': shippingDate.substr(0,10),
              deliveryNo: data.deliveryNo,
              //symptom:data.symptom,
              custSerialNo: data.custSerialNo,
              complaintDateDiff: this.computeShippingComplaintDateDiff(shippingDate, complaintDate),   
              complaintDate:new Date(complaintDate),  
              action:'A'
              // resp:this.pResp
            };
            this.tableData.data.splice(0, 0, j);
            this.tableData.sel = JSON.parse(JSON.stringify(j));
            this.currentIndex = 0;


        }).catch((err) => {
          console.log(err);
        });
      }

    },
    updTableData(row, index, cg) { 
      //是否是取消操作
      if (!cg) {        
        if (!this.tableData.sel.id) this.tableData.data.splice(index, 1);
        return this.currentIndex = -1;;
      } 
      this.genSelsetItem();          
      if(this.currentIndex !=-1 && index != this.currentIndex){
        return this.$message.warning({message:this.$i18n.t('msg.saveFirst'), duration: 800});
      } 
      
      row.action = (row.action != 'A' ? 'U' :row.action) ;
      if (this.currentIndex !=-1 && index == this.currentIndex) {     
        let data = JSON.parse(JSON.stringify(this.modifyUpdData(row)));
        for (let k in data) row[k] = data[k];  
        this.$refs.singleTable.setCurrentRow();
        this.currentIndex = -1;
      } else {
        
        this.tableData.sel = JSON.parse(JSON.stringify(this.modifyUpdData(row)));
        this.$refs.singleTable.setCurrentRow(row);
        this.currentIndex = index;
      }
    },
    modifyUpdData(row){
      
      var d = row.rmaRequestDate;
      if(d != null && d != ''){
        var date = new Date(d);
        row.rmaRequestDate = date.getFullYear() + "-" + CommonUtil.lpad(date.getMonth()+1, 2) + "-" + CommonUtil.lpad(date.getDate(), 2);	
      }  
     
      d = row.rmaEffectiveDate;
      if(d != null && d != ''){
        date = new Date(d);
        row.rmaEffectiveDate = date.getFullYear() + "-" + CommonUtil.lpad(date.getMonth()+1, 2) + "-" + CommonUtil.lpad(date.getDate(), 2);	
      }

      d = row.faeProposalDate;
      if(d != null && d != ''){
        date = new Date(d);
        row.faeProposalDate = date.getFullYear() + "-" + CommonUtil.lpad(date.getMonth()+1, 2) + "-" + CommonUtil.lpad(date.getDate(), 2);	
      }

      d = row.shippingDate;
      if(d != null && d != ''){
        date = new Date(d);
        row.shippingDate = date.getFullYear() + "-" + CommonUtil.lpad(date.getMonth()+1, 2) + "-" + CommonUtil.lpad(date.getDate(), 2);	
      }
      return row;
    },
    delTableData(row, index){  
      this.$confirm(this.$i18n.t('msg.confirmDelete'), {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      })
      .then(_ => {
        this.tableData.data.splice(index, 1);        
        done();
      })
      .catch(_ => {});
    },
    rmaRequestChange(row, index, field){
      debugger
      if(field == 'shippingDate'){
        var complaintDate = row.complaintDate;
        var shippingDate = row.shippingDate;    
     
        row.complaintDateDiff = this.computeShippingComplaintDateDiff(shippingDate, complaintDate); 
      }
          
    },
    sendRmaMail(){
      
      this.$confirm(this.$i18n.t('msg.confirmSendRmaMail'), {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      })
      .then(_ => {
        apiSendFeedbackRmaMail({ headers: authHeader(), id: this.pFeedbackId}).then((response) => {  
          if(response.status== 200 && response.data != null ){
             this.$message({ type: "success", message: this.$i18n.t('msg.sendMailSuccessed'), duration: 800});
          }
        }).catch((err) => {
          console.log(err);
        });
        done();
      })
      .catch(_ => {});


      
    },
    genSelsetItem(){
      var failureStageArr = document.getElementById("failureStageTable").getElementsByTagName('tbody')[0].getElementsByTagName('tr');
      var defectCodeOpt = [], symptomOpt=[];
      if(failureStageArr.length>0){
        for(var i=0 ; i<failureStageArr.length ; i++){
          var col = failureStageArr[i].getElementsByTagName('td');
          symptomOpt.push(col[1].outerText);
          defectCodeOpt.push(col[3].outerText);
        }
      }
      this.tableData.columns.forEach((item) => {
        if(item.field == 'defectCode'){        
          item.selectObj = defectCodeOpt;
        }else if(item.field == 'symptom'){
          item.selectObj = symptomOpt;
        }
      });
    }
    
  }
};
</script>
